<template>
  <a class="event-item" :href="event.url || (event.event && event.event.url)">
    <div class="event-item__content">
      <div class="event-item__media">
        <img
            :src="event.image.src"
            alt="{{ event.title }}"
            class="event-item__image"
            :width="event.image.sizes.thumbnail.width"
            :height="event.image.sizes.thumbnail.height"
        />
      </div>

      <div class="event-item__details">
        <span v-if="event.prefix" class="event-item__prefix">{{ event.prefix }}</span>

        <h3 class="event-item__titles" :aria-label="event.title">
          <span class="event-item__title" aria-hidden="true">
            {{ truncatedTitle }}
          </span>
        </h3>
        <div class="event-item__footer">
          <p class="event-item__date">
            {{ formattedDate }}
          </p>
          <p v-if="event.tessitura && event.tessitura.data && event.tessitura.data.Facility && event.tessitura.data.Facility.Description" class="event-item__location">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="event-pin icon-location-pin" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_55408_1401)">
                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z" fill="black"/>
                <path d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_55408_1401">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <span>{{ event.tessitura.data.Facility.Description }}</span>
          </p>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'WhatsOnEvent',
  props: {
    event: {
      type: Object,
      required: true,
    }
  },
  computed: {
    formattedDate() {
      const start = this.event.startDate || this.event.event?.startDate;
      const end = this.event.endDate || this.event.event?.endDate;
      if (!start) return '';

      const startDate = new Date(start);
      const endDate = end ? new Date(end) : null;
      const now = new Date();
      const currentYear = now.getFullYear();
      const startYear = startDate.getFullYear();
      const endYear = endDate ? endDate.getFullYear() : null;

      const format = (date, opts) => date.toLocaleDateString(undefined, opts);

      let startFormat = { month: 'short', day: 'numeric' };
      let endFormat = { month: 'short', day: 'numeric' };

      if (endDate) {
        const sameDay =
          startDate.getFullYear() === endDate.getFullYear() &&
          startDate.getMonth() === endDate.getMonth() &&
          startDate.getDate() === endDate.getDate();

        if (sameDay) {
          if (startYear !== currentYear) {
            startFormat.year = 'numeric';
          }
          return format(startDate, startFormat);
        }

        if (startYear !== endYear) {
          startFormat.year = 'numeric';
          endFormat.year = 'numeric';
        } else if (startYear !== currentYear) {
          endFormat.year = 'numeric';
        }
        return `${format(startDate, startFormat)} - ${format(endDate, endFormat)}`;
      } else {
        if (startYear !== currentYear) {
          startFormat.year = 'numeric';
        }
        let result = format(startDate, startFormat);

        if (startDate.getHours() !== 0 || startDate.getMinutes() !== 0) {
          result += ' at ' + startDate.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: '2-digit'
          });
        }
        return result;
      }
    },
    truncatedTitle() {
      const title = this.event.title || '';
      return title.length > 25 ? title.slice(0, 25) + '...' : title;
    }
  }
};
</script>